import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import PdfViewer from "../../components/PdfViewer";

const getPdfUrl = locale =>
  ({
    [locale]:
      "https://buscar.terras.app/app/files/politica-de-privacidade-buscar-04-09-2020.pdf",
    'en-US': 'https://buscar.terras.app/app/files/buscar_privacy-policy_09-04-2020.pdf'
  }[locale]);

const PrivacyPolicy = () => {
  const { formatMessage, locale } = useIntl();
  const [pdfUrl, setPdfUrl] = useState(getPdfUrl(locale));

  useEffect(() => {
    setPdfUrl(getPdfUrl(locale));
  }, [locale]);

  return (
    <>
      <h1>{formatMessage({ id: "politica-privacidade" })}</h1>

      <div className="content-box privacy-policy">
        <PdfViewer
          url={pdfUrl}
          title={formatMessage({ id: "politica-privacidade" })}
        />
      </div>
    </>
  );
};

export default PrivacyPolicy;
